import { env } from "@/app/config/env";
import { ApiError } from "@/types/api";
import type { InternalAxiosRequestConfig } from "axios";

export const UPDATE_REQUIRED_PROBLEM =
  "urn:kayer:problem:client-update-required";
let blocked = false;
let inFlight = 0;
const listeners = new Set<() => void>();
const requiredListeners = new Set<() => void>();
const emit = () => listeners.forEach((listener) => listener());
const tracked = new WeakSet<object>();

/** Compatibility is transport-wide, independent of login state or active tenant. */
export function setAppRequestsBlocked(value: boolean) {
  blocked = value;
}
export function getAppRequestsInFlight() {
  return inFlight;
}
export function subscribeAppRequests(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
export function subscribeUpdateRequired(listener: () => void) {
  requiredListeners.add(listener);
  return () => {
    requiredListeners.delete(listener);
  };
}
export function requireAppUpdate() {
  blocked = true;
  requiredListeners.forEach((listener) => listener());
}

/** Track only dispatched application requests; existing submissions are never canceled by the gate. */
export function beginAppRequest(config: InternalAxiosRequestConfig) {
  if (blocked)
    throw new ApiError("http", 409, { type: UPDATE_REQUIRED_PROBLEM });
  config.headers["X-Kayer-App-Version"] = env.VITE_APP_VERSION;
  tracked.add(config);
  inFlight += 1;
  emit();
  return config;
}
export function finishAppRequest(config: object | undefined) {
  if (config && tracked.delete(config)) {
    inFlight -= 1;
    emit();
  }
}
export function observeUpdateProblem(data: unknown) {
  if (
    data &&
    typeof data === "object" &&
    "type" in data &&
    data.type === UPDATE_REQUIRED_PROBLEM
  )
    requireAppUpdate();
}
